import { videoCallEntity } from '@/src/entities/video-call2'

export function useKick(callback: Function) {
  videoCallEntity.model.useWebsocketOnUserKickCall(function () {
    callback()
  })
}
